import React from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./transportationCompleteModal";
import Modal from "..";
import { Button } from "../../../atoms/Buttons";
import { logout } from "../../../../lib/authFunctions";
import { useSetRecoilState } from "recoil";
import { userInfoSelector } from "../../../../states/user";

type TransportationCompleteModalType = {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  onComplete?: () => Promise<void> | void;
};

const TransportationCompleteModal = ({
  setIsModal,
  onComplete,
}: TransportationCompleteModalType) => {
  const navigate = useNavigate();

  const handleConfirmClick = async () => {
    if (onComplete) {
      await onComplete();
    } else {
      navigate("/");
    }
  };

  return (
    <Modal title="운송완료" titlePosition="center" size="md">
      <S.TransportationCompleteModalLayout>
        <span>
          수고 많으셨습니다 <br /> 호랑이얼굴의 최종 승인 후 <br />
          정산 될 예정입니다.
        </span>
        <S.ButtonBox>
          <Button
            type="button"
            size="full"
            color="primary"
            label="확인"
            onClick={handleConfirmClick}
          />
        </S.ButtonBox>
      </S.TransportationCompleteModalLayout>
    </Modal>
  );
};

export default TransportationCompleteModal;
